import { Link } from "@reach/router";
import React, { useState } from "react";
import tbmLogoBlanco from "../../assets/rebrand/logotipo-blanco.png";
import logotipoBlanco from "../../assets/rebrand/logotipo-blanco.png";
import simboloBlanco from "../../assets/rebrand/simbolo-blanco.png";
import logotipoPrimary from "../../assets/rebrand/logotipo-primary.png";
import simboloPrimary from "../../assets/rebrand/simbolo-primary.png";

export default function LandingOnlineMobileNavbar() {
  const [display, setDisplay] = useState(false);

  const handleClickTab = () => {
    setDisplay(false);
  };

  const navLinks = (
    <>
      <li
        className={`nav-item h-max-content
                  `}
      >
        <a
          onClick={handleClickTab}
          className="nav-link mt-0"
          href="#metodo"
        >
          Metodo
        </a>
      </li>
      <li className="nav-item h-max-content">
        <a
          onClick={handleClickTab}
          className="nav-link mt-0 "
          href="#disciplinas"
        >
          Disciplinas
        </a>
      </li>
      <li className="nav-item h-max-content">
        <a
          onClick={handleClickTab}
          className="nav-link mt-0"
          href="#workout-planner"
        >
          Funciones
        </a>
      </li>
      <li className="nav-item h-max-content">
        <a onClick={handleClickTab} className="nav-link mt-0 d-flex align-items-center gap-2" href="#workout-planner">
          <img src={simboloPrimary} alt="" aria-hidden style={{ width: "16px", height: "16px", objectFit: "contain" }} />
          Planner
        </a>
      </li>
      <li className="nav-item h-max-content">
        <a onClick={handleClickTab} className="nav-link mt-0 d-flex align-items-center gap-2" href="#filtros">
          <img src={simboloPrimary} alt="" aria-hidden style={{ width: "16px", height: "16px", objectFit: "contain" }} />
          Filtros
        </a>
      </li>
      <li className="nav-item h-max-content">
        <a onClick={handleClickTab} className="nav-link mt-0 d-flex align-items-center gap-2" href="#favoritas">
          <img src={simboloPrimary} alt="" aria-hidden style={{ width: "16px", height: "16px", objectFit: "contain" }} />
          Favoritas
        </a>
      </li>
      <li className="nav-item h-max-content">
        <a
          onClick={handleClickTab}
          className="nav-link mt-0"
          href="#testimonios"
        >
          Testimonios
        </a>
      </li>
      <li className="nav-item h-max-content">
        <a className="nav-link mt-0" href="/paquetes/">
          Paquetes
        </a>
      </li>
      <li className="nav-item h-max-content">
        <a
          onClick={handleClickTab}
          className="nav-link mt-0"
          href="/rewards/"
        >
          Rewards
        </a>
      </li>
    </>
  );

  return (
    <nav
      id="navbar-landing-online-mobile"
      className="navbar navbar-expand-lg position-absolute navbar-light mx-auto d-flex d-lg-none flex-column flex-nowrap shadow-none w-100 landing-online-mnav ps-1"
      style={{
        zIndex: 1000,
      }}
    >
      <div className="container-fluid px-0 w-100">
        <div className="landing-online-mnav__top-row d-flex align-items-center justify-content-between w-100 position-relative">
          <a className="navbar-brand p-0 d-flex align-items-center gap-2" href="/#landing">
            <img src={simboloBlanco} alt="" aria-hidden style={{ height: "2.25rem", width: "auto" }} />
            <img src={logotipoBlanco} alt="The Body Method" style={{ height: "2.2rem", width: "auto", objectFit: "contain", marginLeft: "-8px" }} />
          </a>
          <div className="landing-online-mnav__actions d-flex align-items-center gap-2 flex-shrink-0">
            <Link
              className="btn btn-primary bold online-navbar__login-btn"
              to="/entrar"
            >
              <i className="fa fa-user"></i>{" "}
              <span className="ms-1">Ingresar</span>
            </Link>
            <button
              className="navbar-toggler bg-transparent border border-light d-md-none"
              type="button"
              aria-controls="navbarNav"
              aria-expanded={display}
              aria-label="Toggle navigation"
              onClick={() => setDisplay(!display)}
            >
              <i className="fas fa-bars text-white" />
            </button>
          </div>
        </div>

        <div className="landing-online-mnav__menu-md d-none d-md-block d-lg-none w-100 mt-3">
          <div className="container-fluid px-0">
            <ul className="navbar-nav nav flex-row flex-wrap justify-content-center align-items-center gap-1 gap-md-2">
              <li
                className={`nav-item h-max-content
                `}
              >
                <a className="nav-link mt-0 py-1" href="#metodo">
                  Metodo
                </a>
              </li>
              <li className="nav-item h-max-content">
                <a className="nav-link mt-0 py-1" href="#disciplinas">
                  Disciplinas
                </a>
              </li>
              <li className="nav-item h-max-content position-relative funciones-dropdown">
                <button
                  className="nav-link dropdown-toggle border-0 bg-transparent py-1 shadow-none"
                  type="button"
                  aria-expanded="false"
                  id="funciones-mobile-md"
                >
                  Funciones
                </button>
                <ul
                  className="dropdown-menu funciones-menu"
                  aria-labelledby="funciones-mobile-md"
                  style={{
                    top: "100%",
                    left: "0",
                  }}
                >
                  <li>
                    <a href="#workout-planner" className="dropdown-item">
                      Planner
                    </a>
                  </li>
                  <li>
                    <a href="#filtros" className="dropdown-item">
                      Filtros
                    </a>
                  </li>
                  <li>
                    <a href="#favoritas" className="dropdown-item">
                      Favoritas
                    </a>
                  </li>
                </ul>
              </li>
              <li className="nav-item h-max-content">
                <a className="nav-link mt-0 py-1" href="#testimonios">
                  Testimonios
                </a>
              </li>
              <li className="nav-item h-max-content">
                <a className="nav-link mt-0 py-1" href="/paquetes/">
                  Paquetes
                </a>
              </li>
              <li className="nav-item h-max-content">
                <a className="nav-link mt-0 py-1" href="/rewards/">
                  Rewards
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        className="drawer-menu d-md-none landing-online-mnav__drawer"
        style={{
          position: "fixed",
          top: "0",
          left: display ? 0 : "-100vw",
          width: "100vw",
          height: "100vh",
          backgroundColor: "#fdf6f0",
          zIndex: 2000,
          display: "flex",
          flexDirection: "column",
          transition: "left 0.3s ease",
          overflowY: "auto",
        }}
      >
        {/* Drawer header */}
        <div
          className="w-100 d-flex align-items-center justify-content-between px-4 py-3 flex-shrink-0"
          style={{ backgroundColor: "#fdf6f0", borderBottom: "1px solid rgba(0,0,0,0.08)" }}
        >
          <a href="/#landing" onClick={() => setDisplay(false)} className="d-flex align-items-center gap-2">
            <img
              src={simboloPrimary}
              alt=""
              aria-hidden
              style={{ height: "2.25rem", width: "auto" }}
            />
            <img
              src={logotipoPrimary}
              alt="The Body Method"
              style={{ height: "2.5rem", width: "auto", objectFit: "contain" }}
            />
          </a>
          <button
            type="button"
            className="btn border-0 bg-transparent p-0"
            onClick={() => setDisplay(false)}
            aria-label="Cerrar menú"
          >
            <i className="fas fa-times text-dark" style={{ fontSize: "22px" }} />
          </button>
        </div>

        {/* Nav links */}
        <ul className="navbar-nav nav flex-column px-3 py-4 gap-1 flex-grow-1">
          {navLinks}
        </ul>

        {/* Footer CTA */}
        <div className="px-4 pb-5 pt-2 flex-shrink-0">
          <Link
            className="btn btn-primary bold w-100 py-3"
            style={{ borderRadius: "40px", fontSize: "16px" }}
            to="/entrar"
            onClick={() => setDisplay(false)}
          >
            <i className="fa fa-user me-2" />
            Ingresar
          </Link>
        </div>
      </div>
    </nav>
  );
}
